export enum OfficeHoursTabs {
  SCHEDULED = 'scheduled',
  UPCOMING = 'upcoming',
}
